/* HIRO engagement: recently viewed, "Welcome back", quick add and the promo slide-in. Replaces the Cooee app.
   Recently viewed product ids live in localStorage.recentlyViewedProducts (written by sections/main-product.liquid and by
   the window.HIRO_PRODUCT_ID line in layout/theme.liquid). */
(function () {
  'use strict';

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  function readIds() {
    try { return JSON.parse(store.get('recentlyViewedProducts') || '[]').filter(Boolean); } catch (e) { return []; }
  }

  // Returning visitor = first page of a new session, with a visit on record from before.
  var returning = store.sget('hiroReturning');
  if (returning === null) {
    returning = store.get('hiroLastVisit') ? '1' : '0';
    store.sset('hiroReturning', returning);
  }
  store.set('hiroLastVisit', String(Date.now()));

  // Record the product being viewed, for templates that don't use main-product.
  if (window.HIRO_PRODUCT_ID) {
    var ids = readIds().filter(function (id) { return id !== window.HIRO_PRODUCT_ID; });
    ids.unshift(window.HIRO_PRODUCT_ID);
    store.set('recentlyViewedProducts', JSON.stringify(ids.slice(0, 8)));
  }

  /* Recently viewed strips */
  function fillStrip(el) {
    var exclude = parseInt(el.getAttribute('data-exclude'), 10);
    var limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
    var ids = readIds().filter(function (id) { return id !== exclude; }).slice(0, limit);
    if (!ids.length) return;

    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var base = (window.routes && window.routes.searchUrl) || '/search';
    fetch(base + '?type=product&section_id=hiro-rv-items&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var items = tmp.querySelector('.hrv-items');
        if (!items || !items.children.length) return;
        el.querySelector('[data-hiro-rv-track]').innerHTML = items.innerHTML;
        var alt = el.getAttribute('data-heading-returning');
        if (alt && returning === '1') el.querySelector('[data-hiro-rv-heading]').textContent = alt;
        el.hidden = false;
      })
      .catch(function () {});
  }

  /* Quick add: posts to the cart, then lets the theme re-render and open the drawer */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hiro-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var variantId = parseInt(btn.getAttribute('data-hiro-add'), 10);
    fetch(((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (variant) {
      btn.textContent = 'Added';
      var drawer = document.getElementById('sidebar-cart');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        // Already in the open drawer: just re-render it
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } else {
        document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: variant, quantity: 1 } }));
      }
    }).catch(function () {
      btn.textContent = label;
      btn.disabled = false;
      window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
    });
  });

  /* Slide-in */
  function initSlideIn() {
    var el = document.getElementById('hiro-slidein');
    if (!el) return;
    var key = 'hiroSlideIn:' + (el.getAttribute('data-key') || 'promo');
    var until = parseInt(store.get(key) || '0', 10);
    if (until > Date.now() || store.sget(key)) return;

    var delay = (parseInt(el.getAttribute('data-delay'), 10) || 20) * 1000;
    var scrollPct = (parseInt(el.getAttribute('data-scroll'), 10) || 50) / 100;
    var snoozeDays = parseInt(el.getAttribute('data-snooze'), 10) || 7;
    var shown = false;
    var timer;

    // Wait while a cookie banner, sign-up pop-up or drawer is open.
    function busy() {
      var sel = '#shopify-pc__banner, [aria-modal="true"], [role="dialog"]:not(#hiro-slidein), .Drawer[aria-hidden="false"]';
      return Array.prototype.some.call(document.querySelectorAll(sel), function (n) {
        if (n.getAttribute('aria-hidden') === 'true') return false;
        var r = n.getBoundingClientRect();
        if (!r.width || !r.height) return false;
        var s = getComputedStyle(n);
        if (s.visibility === 'hidden' || s.display === 'none' || s.opacity === '0') return false;
        if (n.shadowRoot && !n.shadowRoot.querySelector('form, [role="dialog"], button')) return false;
        return true;
      });
    }

    function snooze(days) {
      store.set(key, String(Date.now() + days * 864e5));
    }

    function show() {
      if (shown) return;
      if (busy()) { clearTimeout(timer); timer = setTimeout(show, 8000); return; }
      shown = true;
      window.removeEventListener('scroll', onScroll);
      store.sset(key, '1'); // once per visit
      el.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    }

    function hide(days) {
      snooze(days);
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; }, 450);
    }

    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= scrollPct) show();
    }

    timer = setTimeout(show, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    el.querySelector('[data-hsi-close]').addEventListener('click', function () { hide(snoozeDays); });
    el.querySelector('[data-hsi-go]').addEventListener('click', function () { snooze(30); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && shown && !el.hidden) hide(snoozeDays); });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hiro-rv]'), fillStrip);
    initSlideIn();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
